import organizationReducer from "./organizationReducer";

const organizationReducers = {
    organization: organizationReducer
}

export default organizationReducers;